<template><section><h2>Nightingale Group Chart 分组图</h2>
<block-demo tip="" source="const data = [
  {
    product: &quot;05-08&quot;,
    year: &quot;图例一&quot;,
    sales: 3000,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例二&quot;,
    sales: 1000,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例三&quot;,
    sales: 2000,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例一&quot;,
    sales: 3000,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例二&quot;,
    sales: 1000,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例三&quot;,
    sales: 2000,
  },

  {
    product: &quot;05-10&quot;,
    year: &quot;图例一&quot;,
    sales: 1700,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例二&quot;,
    sales: 2400,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例三&quot;,
    sales: 3700,
  },

  {
    product: &quot;05-11&quot;,
    year: &quot;图例一&quot;,
    sales: 4200,
  },
  {
    product: &quot;05-11&quot;,
    year: &quot;图例二&quot;,
    sales: 2800,
  },
  {
    product: &quot;05-11&quot;,
    year: &quot;图例三&quot;,
    sales: 3100,
  },

  {
    product: &quot;05-12&quot;,
    year: &quot;图例一&quot;,
    sales: 5100,
  },
  {
    product: &quot;05-12&quot;,
    year: &quot;图例二&quot;,
    sales: 2500,
  },
  {
    product: &quot;05-12&quot;,
    year: &quot;图例三&quot;,
    sales: 350,
  },
]
const { Chart, PolarBar, Tooltip, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;year&quot;,
  value: &quot;sales&quot;,
  text: &quot;product&quot;,
})
const bar = new PolarBar({
  innerRadius: 0.3,
  radius: 0.7,
  groupPadAngle: 30,
})
const legend = new Legend()
const tooltip = new Tooltip()

chart.append([bar, tooltip, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">1000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">1000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2000</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">1700</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2400</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3700</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">4200</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2800</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3100</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">5100</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2500</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">350</span>,
  },
]
<span class="hljs-keyword">const</span> { Chart, PolarBar, Tooltip, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> PolarBar({
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.3</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.7</span>,
  <span class="hljs-attr">groupPadAngle</span>: <span class="hljs-number">30</span>,
})
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()

chart.append([bar, tooltip, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>